import React, {useContext, useEffect} from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import KeywordGroups from "../client_config/seo_config/keyword_groups/KeywordGroups";
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import SkipButton from "./SkipButton";
import getNextPage from "./getNextPage";
import {RouterContext} from "./Onboarding"

export default function KeywordGroupsOB(props) {
  const route = useContext(RouterContext)

  const nextPage = getNextPage(props.onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem(
      "routerHistory",
      JSON.stringify([...route.get])
    );
  }, [route.get]);
  let exclaimCircle = require("images/onboarding/exclaim-circle.png");
  exclaimCircle = <img className="" src={`/datapulse${exclaimCircle}`} />;
  props.pageLocator();
  return (
    <>
      <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
      <Row className="px-lg-4 px-0 justify-content-center">
        <Col md={7}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">Keyword Groups</p>
          </div>
          <div>
            <p className="f14 nunito-regular primary ">
              In this section, you can configure keyword groups. It's very important that these entries are configured correctly - failing to do so can return
              skewed or undesirable reporting. Click 'Show me some examples' to the right to learn more about properly configuring your keyword groups. Labels
              are for reference only and will not affect the reporting (besides how it is titled in the performance dashboard).
            </p>
          </div>
        </Col>
      </Row>
      <KeywordGroups {...props} onboarding />
      <Row className="pb-3 justify-content-center">
        <Col md={5}>
          <Row className="align-items-center">
            <Col className="pr-md-0 text-center text-md-left pb-2 pb-md-0" md={1}>
              {exclaimCircle}
            </Col>
            <Col>
              <p className="f12  primary">
                Improper configuration of keywords can have misleading results showing for different keyword groups. Please double-check your BKI entries
                before continuing or click 'Show me some examples' if unsure.
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="mt-5 justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton 
              btnText={`Skip for now`}
              nextPage={nextPage.url}
            />
            <NextButton
              validated={true} 
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
